import { useEffect, useRef } from 'react';

const BrandHeader = () => {
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          headerRef.current?.classList.add('opacity-100', 'translate-y-0');
          headerRef.current?.classList.remove('opacity-0', 'translate-y-6');
        }
      },
      { threshold: 0.2 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative w-full overflow-hidden" style={{ minHeight: '420px' }}>
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/4b6d7b0c09256dd4882e812839ce2f28.jpg"
          alt="Vinícola Guarnieri - tradição familiar"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
      </div>

      {/* Decorative vine pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: `radial-gradient(circle at 20% 50%, rgba(180,120,40,0.3) 0%, transparent 50%),
                              radial-gradient(circle at 80% 50%, rgba(120,30,30,0.3) 0%, transparent 50%)`
          }}
        ></div>
      </div>

      {/* Content */}
      <div
        ref={headerRef}
        className="relative z-10 flex flex-col items-center justify-center text-center px-4 md:px-8 opacity-0 translate-y-6 transition-all duration-1000 ease-out"
        style={{ minHeight: '420px', paddingTop: '80px', paddingBottom: '60px' }}
      >
        {/* Decorative line */}
        <div className="flex items-center gap-4 mb-6">
          <div className="w-16 md:w-24 h-px bg-[#c9a96e]/60"></div>
          <i className="ri-plant-line text-[#c9a96e] text-lg"></i>
          <div className="w-16 md:w-24 h-px bg-[#c9a96e]/60"></div>
        </div>

        {/* Brand Name */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-widest uppercase mb-4" style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '0.12em' }}>
          Vinhos
        </h1>
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-[#c9a96e] uppercase mb-6" style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '0.08em' }}>
          Guarnieri
        </h1>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 md:w-20 h-px bg-white/30"></div>
          <div className="w-2 h-2 rounded-full bg-[#c9a96e]/80"></div>
          <div className="w-12 md:w-20 h-px bg-white/30"></div>
        </div>

        {/* Tagline */}
        <p className="text-white/85 text-base md:text-xl lg:text-2xl font-light italic max-w-2xl leading-relaxed" style={{ fontFamily: "'Playfair Display', serif" }}>
          "a união entre a tradição familiar e a qualidade artesanal"
        </p>

        {/* Bottom decorative */}
        <div className="flex items-center gap-4 mt-8">
          <div className="w-8 h-px bg-[#c9a96e]/40"></div>
          <i className="ri-goblet-line text-[#c9a96e]/60 text-sm"></i>
          <div className="w-8 h-px bg-[#c9a96e]/40"></div>
        </div>
      </div>
    </section>
  );
};

export default BrandHeader;
